/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

import {
  ChangeDetectorRef,
  Component,
  OnInit, QueryList, ViewChild, ViewChildren
} from '@angular/core';

import { Logger                } from '@/util/logger';
import { MatSidenav }            from "@angular/material/sidenav";
import {first}                   from "rxjs/operators";
import { SortEvent }             from 'primeng/api';
import {ISubdivisionRow} from "@/screens/administration/i.subdivision.row";
import {SubdivisionService} from "@/services/subdivision.service";
import {Inplace, InplaceContent} from "primeng/inplace";
import {KeyboardEvent} from "@/components/krpano/events/keyboard.event";
import {fromMySQLDate} from "@/util/util";

@Component({
  standalone: false,
  templateUrl: 'subdivisions.list.component.html'
})

/**
 *
 * @class SubdivisionsListComponent
 *
 * @brief subdivision management page
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      August 2022
 *
 */
export class SubdivisionsListComponent implements OnInit {

  @ViewChild('adminsidenav')
  public nav: MatSidenav;

  /** the list of CSV style entries for each subdivision in the system */
  public subdivisions: ISubdivisionRow[] = [];

  /** standard constructor */
  constructor(
    private subservice: SubdivisionService,
    private cdRef:  ChangeDetectorRef
  ) {


  }

  refresh() {

    let sl: SubdivisionsListComponent = this;

    Logger.debug(`[SubdivisionsListComponent] looking for subdivisions...`);

    sl.subservice.dump()
      .pipe(first())
      .subscribe({

        next: (data: any): void => {

          sl.subdivisions = [];

          if (data.result) {

            data = data.result;
          }

          data.forEach((item) => {

            item.created_at = fromMySQLDate(item.created_at).toLocaleString().slice(0, 19).replace(',', '');
            item.updated_at = fromMySQLDate(item.updated_at).toLocaleString().slice(0, 19).replace(',', '');

            sl.subdivisions.push(item);


          });

          sl.cdRef.detectChanges();

          Logger.debug(`[SubdivisionsListComponent] subdivisions: `, sl.subdivisions);

        },

        error: (error: any): void => {

          Logger.error(`[SubdivisionsListComponent] could not fetch subdivision details: `, error);

        }

      });
  }

  /** on page setup */
  ngOnInit() {

    let sl: SubdivisionsListComponent = this;

    Logger.debug('[SubdivisionsListComponent] init...');

    sl.refresh();

  }

  createSubdivision(event = null) {

    let sl: SubdivisionsListComponent = this;
    let name: string = $(`#createsubdivision`).val().toString();

    if (event != null) {

      /* if it's a key up change, only trigger on RETURN */

      if (event.key != 'Enter') {

        /* they are just typing, ignore. */

        return ;
      }

    }

    $(`#createsubdivision`).val('');

    Logger.debug(`[SubdivisionsListComponent] creating new subdivision: '${name}'...`);

    sl.subservice.create({name})
      .pipe(first())
      .subscribe({

        next: (data: any): void => {

          Logger.debug(`[SubdivisionsListComponent] subdivision created, refreshing...`);

          sl.refresh();

        },

        error: (error: any): void => {

          Logger.error(`[SubdivisionsListComponent] could not create subdivision: `, error);
        }

      });

  }

  /** set a new name for the given subdivisions */
  saveSubName(id: number, name: string) {

    let sl: SubdivisionsListComponent = this;

    let sub: ISubdivisionRow = sl.subdivisions.find(x => x.id == id);

    if (!sub) {

      return ;
    }

    /* update locally */

    sub.name = name;

    /* update the database... */

    sl.subservice.update(id, {name})
      .pipe(first())
      .subscribe({

        next: (data: any): void => {

          /* refresh the list ... */

          sl.refresh();

        },

        error: (error: any): void => {

          Logger.error(`[SubdivisionsListComponent] could not save new subdivision name: `, error);

        }

      });

  }

  subEditKey(event, id: number, component: Inplace) {

    let sl: SubdivisionsListComponent = this;
    let value: string = $(`.subclass-${id} input`).val().toString();

    if (event.key != 'Enter') {

      return ;
    }

    Logger.debug(`[SubdivisionsListComponent] sub editor RETURN (${id}) => '${value}': `, event);

    sl.saveSubName(id, value);

  }

  subEditDeactivate(id: number, component: Inplace) {

    let sl: SubdivisionsListComponent = this;
    let value: string = $(`.subclass-${id} input`).val().toString();

    Logger.debug(`[SubdivisionsListComponent] deactivating sub editor (${id}) => '${value}': `, component);

    sl.saveSubName(id, value);

  }

  subEditActivate(id: number, component: Inplace) {

    let sl: SubdivisionsListComponent = this;

    Logger.debug(`[SubdivisionsListComponent] activating sub editor (${id}): `, component);




  }

  /** check if a subdivision is deletable */
  canDelete(id: number|string) {

    let sl: SubdivisionsListComponent = this;
    let sub: ISubdivisionRow          = sl.subdivisions.find(x => x.id == id);

    if (!sub) {

      return false;
    }

    let usage: number = sub.users.length + sub.organizations.length + sub.projects.length;

    if (usage == 0) {

      return true;
    }

    /* still in use somewhere */

    return false;
  }

  /** soft delete a subdivision */
  deleteSubdivision(id: number|string) {

    let sl: SubdivisionsListComponent = this;

    Logger.debug(`[SubdivisionsListComponent] deleting: ${id} ...`);

    sl.subservice.deleteSubdivision(id)
      .pipe(first())
      .subscribe({

        next: (data: any): void => {

          if (data.result) {

            data = data.result;
          }

          let row: ISubdivisionRow = data;

          let sub: ISubdivisionRow = sl.subdivisions.find(x => x.id == row.id);

          sub.is_deleted = true;

          sl.cdRef.detectChanges();
        },

        error: (error: any): void => {

          Logger.error(`[SubdivisionsListComponent] could not delete subdivisions: `, error);

        }

      });
  }

  /** undelete a subdivision */
  unDeleteSubdivision(id: number|string) {

    let sl: SubdivisionsListComponent = this;

    Logger.debug(`[SubdivisionsListComponent] activating: ${id} ...`);

    sl.subservice.undeleteSubdivision(id)
      .pipe(first())
      .subscribe({

        next: (data: any): void => {

          if (data.result) {

            data = data.result;
          }

          let row: ISubdivisionRow = data;

          let sub: ISubdivisionRow = sl.subdivisions.find(x => x.id == row.id);

          sub.is_deleted = false;

          sl.cdRef.detectChanges();
        },

        error: (error: any): void => {

          Logger.error(`[SubdivisionsListComponent] could not delete subdivisions: `, error);

        }

      });


  }

  /** expand/collapse the sidebar navigation panel */
  toggleSidebar() {

    this.nav.toggle();
  }

  /** helper to sort special rows like disk usage */
  tableSort(event: SortEvent) {

    let sl: SubdivisionsListComponent = this;

    event.data.sort((data1, data2) => {

      let value1 = data1[event.field];
      let value2 = data2[event.field];

      /* deal with missing data */

      if (value1 == null && value2 != null) {

        return -1;

      } else if (value1 != null && value2 == null) {

        return 1;

      } else if (value1 == null && value2 == null) {

        return 0;
      }

      if (['id'].includes(event.field)) {

        /* straight number compare */

        return (parseFloat(value2) - parseFloat(value1)) * event.order;
      }

      if (['name'].includes(event.field)) {

        /* straight string compare */

        return (value1.toString().localeCompare(value2.toString())) * event.order;
      }

      if (event.field == 'created_at') {

        /* date compare */

        /* in some browsers the date format may not be 2025-01-05 11:30:10, it may be 01/05/2025 11:30:10 */

        if (/\//.test(value1)) {

          const t1 = value1.split(/[- :/]/);
          const d1 = new Date(Date.UTC(t1[2], t1[0] - 1, t1[1], t1[3], t1[4], t1[5]));

          const t2 = value2.split(/[- :/]/);
          const d2 = new Date(Date.UTC(t2[2], t2[0] - 1, t2[1], t2[3], t2[4], t2[5]));

          return (d2.getTime() - d1.getTime()) * event.order;

        } else {


          const t1 = value1.split(/[- :/]/);
          const d1 = new Date(Date.UTC(t1[0], t1[1] - 1, t1[2], t1[3], t1[4], t1[5]));

          const t2 = value2.split(/[- :]/);
          const d2 = new Date(Date.UTC(t2[0], t2[1] - 1, t2[2], t2[3], t2[4], t2[5]));

          return (d2.getTime() - d1.getTime()) * event.order;
        }
      }

      /* can not interpret */

      return 0;
    });

    sl.cdRef.detectChanges();
  }

}
